import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'
import Switch from 'react-switch';

// utils
import { showMessage } from "utils/message.js";
import { getSessionCookie } from "utils/cookies.js";

// api
import usuario_api from "api/usuario_api.js";
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import { formateDateAndTimeApi } from 'utils/formats';

export default function UsuarioFicha({ item, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [isDisable, set_isDisable] = useState(true);

    // Status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" }
    ];
    const [status, set_status] = useState(null);
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    // Perfil
    const [options_perfil, set_options_perfil] = useState([]);
    const loadOptionsPerfis = () => {
        usuario_api.getPerfisCadastro().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _perfis = [];
                result.data.map((m) => _perfis.push({ label: m, value: m }));
                set_options_perfil(_perfis);
            }
        });
    }
    const [perfil, set_perfil] = useState(null);
    const handleChangePerfil = (value) => {
        set_perfil(value);
        clearErrors("perfil");
        setValue("perfil", value, true);

        loadOptionsFuncionalidades(value);

        if (value == "Canal" || value == "Regional") {
            set_regionais([]);
            loadOptionsRegionais();
        }
        if (value == "Grupo Econômico") {
            set_grupoeconomico(null);
            set_lojas(null);
            set_options_lojas([]);
            loadOptionsGruposEconomicos();
        }
    }

    // Regionais
    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        dadosimplantacaotim_api.getRegionais().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _regionais = [];
                result.data.map((m) => _regionais.push({ label: m, value: m }));
                set_options_regionais(_regionais);
            }
        })
    }
    const [regionais, set_regionais] = useState([]);
    const handleChangeRegionais = (value) => {
        let _regionais = [];
        if (perfil == "Canal") {
            if (value) {
                value.map(m => {
                    _regionais.push({
                        regional: m.value,
                        usuario_Id: item != null ? item.usuario_Id : 0,
                        usuarioRegional_Id: item != null ? item.usuarioRegionais.filter(f => f.regional == m.value)[0]?.usuarioRegional_Id : 0
                    });
                })
            }
        }
        else if (perfil == "Regional") {
            _regionais.push({
                regional: value.value,
                usuario_Id: item != null ? item.usuario_Id : 0,
                usuarioRegional_Id: item != null ? item.usuarioRegionais.filter(f => f.regional == value.value)[0]?.usuarioRegional_Id : 0
            });
        }

        set_regionais(_regionais);

        if (_regionais.length > 0) {
            setValue("regionais", _regionais, true);
            clearErrors("regionais");
        }
        else {
            setValue("regionais", [], false);
        }
    }

    // Grupos Econômicos
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);
    const loadOptionsGruposEconomicos = () => {
        dadosimplantacaotim_api.getGruposEconomicos().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));
                set_options_gruposeconomicos(_gruposeconomicos);
            }
        })
    }
    const [grupoeconomico, set_grupoeconomico] = useState([]);
    const handleChangeGrupoEconomico = (value) => {
        set_grupoeconomico(value);
        set_lojas([]);
        loadOptionsLojas(value);
    }

    // Lojas
    const [options_lojas, set_options_lojas] = useState([]);
    const loadOptionsLojas = (_grupoeconomico) => {

        let _gruposeconomicosArray = [];
        if(_grupoeconomico !== null)
            _grupoeconomico.map((m) => _gruposeconomicosArray.push(m.value));
        else
            _grupoeconomico = null;

        dadosimplantacaotim_api.getLojasbyGruposEconomicos(_gruposeconomicosArray).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_lojas(result.data);
            }
        })
    }
    const [lojas, set_lojas] = useState([]);
    const handleChangeLojas = (value) => {
        let _lojas = [];
        if (value) {
            value.map(m => {
                _lojas.push({
                    tbDadosImplantacaoTim_Id: m.dadosImplantacaoTim_Id,
                    usuario_Id: item != null ? item.usuario_Id : 0,
                    usuarioGrupoEconomico_Id: item != null ? item.usuarioGruposEconomicos.filter(f => f.tbDadosImplantacaoTim_Id == m.dadosImplantacaoTim_Id)[0]?.usuarioGrupoEconomico_Id : 0
                });
            })
        }

        set_lojas(_lojas);

        if (_lojas.length > 0) {
            setValue("lojas", _lojas, true);
            clearErrors("lojas");
        }
        else {
            setValue("lojas", [], false);
        }
    }

    // Funcionalidades
    const [options_funcionalidades, set_options_funcionalidades] = useState([]);
    const loadOptionsFuncionalidades = (_perfil) => {
        usuario_api.getFuncionalidades(_perfil).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_funcionalidades(result.data);
            }
        });
    }
    const [usuarioFuncionalidadeAcoes, set_usuarioFuncionalidadeAcoes] = useState([]);
    const handleChangeFuncionalidadesAcoes = (funcionalidadeAcao_Id, checked) => {
        let _acoesUsuario = usuarioFuncionalidadeAcoes.filter(f => f.funcionalidadeAcao_Id != funcionalidadeAcao_Id);
        if (checked) {
            _acoesUsuario.push({
                usuarioFuncionalidadeAcao_Id: item ? item.usuarioFuncionalidadeAcos.filter(f => f.funcionalidadeAcao_Id == funcionalidadeAcao_Id)[0]?.usuarioFuncionalidadeAcao_Id : 0,
                usuario_Id: item ? item.usuario_Id : 0,
                funcionalidadeAcao_Id: funcionalidadeAcao_Id
            });
        }

        set_usuarioFuncionalidadeAcoes(_acoesUsuario);
    }

    // Receitas Adicionais Permission
    const [permiteEditarReceitasAdicionais, setPermiteEditarReceitasAdicionais] = useState(false);
    const handleChangeReceitasAdicionaisPermission = (checked) => {
        setPermiteEditarReceitasAdicionais(checked);
    }

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("Usuarios", "Editar").then((result) => { set_isDisable(!result); });
        loadOptionsPerfis();
        loadForm();
    }, []);

    const loadForm = () => {
        if (item != null) {
            setValue("login", item.login);
            setValue("nome", item.nome);
            setValue("email", item.email);
            set_status(item.status);
            setValue("status", item.status, true);
            set_perfil(item.perfil);
            setValue("perfil", item.perfil, true);

            if (item.perfil == "Canal" || item.perfil == "Regional") {
                loadOptionsRegionais();
                set_regionais(item.usuarioRegionais);
                setValue("regionais", item.usuarioRegionais, true);
            }

            if (item.perfil == "Grupo Econômico") {
                loadOptionsGruposEconomicos();

                if (item.usuarioGruposEconomicos.length > 0) {
                    loadGeP(item.usuarioGruposEconomicos)
                    set_lojas(item.usuarioGruposEconomicos)
                    setValue("lojas", item.usuarioGruposEconomicos, true);
                }
            }

            loadOptionsFuncionalidades(item.perfil);
            set_usuarioFuncionalidadeAcoes(item.usuarioFuncionalidadeAcos);
            setPermiteEditarReceitasAdicionais(item.permiteEditarReceitasAdicionais || false);
        }
    }

    const loadGeP = (usuarioGe) =>{
        let _gruposeconomicos = [];
        usuarioGe.map((m) => {
            if(_gruposeconomicos.filter(f => f.value == m.tbDadosImplantacaoTim.tbDadosImplantacaoTim_GrupoEconomico).length === 0)
            {
                _gruposeconomicos.push({ 
                    label: m.tbDadosImplantacaoTim.tbDadosImplantacaoTim_GrupoEconomico,
                    value: m.tbDadosImplantacaoTim.tbDadosImplantacaoTim_GrupoEconomico }
                )
            }
        });
     
        set_grupoeconomico(_gruposeconomicos);
        loadOptionsLojas(_gruposeconomicos);
    }

    const onSubmit = (data) => {
        let json_submit = {
            usuario_Id: item ? item.usuario_Id : 0,
            nome: data.nome,
            login: data.login,
            perfil: perfil,
            status: status,
            email: data.email,
            dataCadastro: formateDateAndTimeApi(new Date()),
            usuarioRegionais: regionais,
            usuarioGruposEconomicos: lojas,
            usuarioFuncionalidadeAcos: usuarioFuncionalidadeAcoes,
            permiteEditarReceitasAdicionais: permiteEditarReceitasAdicionais
        };

        setshowLoading(true);
        if (json_submit.usuario_Id == 0)
            usuario_api.post(json_submit).then(result => handleReturnSubmit(result));
        else
            usuario_api.put(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <h5>Dados do Usuário</h5>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg="3" md="12" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Login</label>
                                <Input className="form-control"
                                    autoComplete="off"
                                    type="text"
                                    name="login"
                                    disabled={isDisable}
                                    innerRef={register({ required: true })}
                                />
                                {errors.login && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="6" md="12" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Nome</label>
                                <Input className="form-control"
                                    autoComplete="off"
                                    type="text"
                                    name="nome"
                                    disabled={isDisable}
                                    innerRef={register({ required: true })}
                                />
                                {errors.nome && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="3" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Status</label>
                                <Select
                                    name="status"
                                    options={options_status}
                                    getOptionLabel={o => o.label}
                                    getOptionValue={o => o.value}
                                    value={options_status.filter(f => f.value == status)}
                                    onChange={(o) => handleChangeStatus(o.value)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    ref={e => register(
                                        { name: "status" },
                                        { required: true })
                                    }
                                    isDisabled={isDisable}
                                />
                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="3" md="6" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Perfil</label>
                                <Select
                                    name="perfil"
                                    options={options_perfil}
                                    getOptionLabel={o => o.label}
                                    getOptionValue={o => o.value}
                                    value={options_perfil.filter(f => f.value == perfil)}
                                    onChange={(o) => handleChangePerfil(o.value)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    ref={e => register(
                                        { name: "perfil" },
                                        { required: true })
                                    }
                                    isDisabled={isDisable}
                                />
                                {errors.perfil && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="6" md="12" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Email</label>
                                <Input className="form-control"
                                    autoComplete="off"
                                    type="text"
                                    name="email"
                                    innerRef={register({ required: true })}
                                    disabled={isDisable}
                                />
                                {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>

                        <Col lg="12" md="12" sm="12" className={(perfil == "Canal" || perfil == "Regional") ? "" : "d-none"}>
                            <FormGroup>
                                <label className="form-control-label">{perfil == "Canal" ? "Regionais" : "Regional"}</label>
                                <Select
                                    name="regionais"
                                    options={options_regionais}
                                    value={options_regionais.filter(({ value }) => regionais.filter(f => f.regional == value).length > 0)}
                                    onChange={(o) => handleChangeRegionais(o)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    isMulti={perfil == "Canal" ? true : false}
                                    ref={e => register(
                                        { name: "regionais" },
                                        { required: perfil == "Canal" || perfil == "Regional" })
                                    }
                                    isDisabled={isDisable}
                                />
                                {errors.regionais && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="12" md="12" sm="12" className={perfil == "Grupo Econômico" ? "" : "d-none"}>
                            <FormGroup>
                                <label className="form-control-label">Grupo Econômico</label>
                                <Select
                                    name="grupoeconomico"
                                    options={options_gruposeconomicos}
                                    getOptionLabel={o => o.label}
                                    getOptionValue={o => o.value}
                                    //value={options_gruposeconomicos.filter(f => f.value == grupoeconomico)}
                                    //onChange={(o) => handleChangeGrupoEconomico(o)}
                                    value={grupoeconomico}
                                    onChange={(o) => handleChangeGrupoEconomico(o)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    isMulti={true}
                                    ref={e => register({ name: "grupoeconomico" })
                                    }
                                    isDisabled={isDisable}
                                />
                                {errors.grupoeconomico && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="12" md="12" sm="12" className={perfil == "Grupo Econômico" ? "" : "d-none"}>
                            <FormGroup>
                                <label className="form-control-label">Lojas</label>
                                <Select
                                    name="lojas"
                                    options={options_lojas}
                                    getOptionLabel={o => o.identificacao}
                                    getOptionValue={o => o.dadosImplantacaoTim_Id}
                                    value={options_lojas.filter(({ dadosImplantacaoTim_Id }) => lojas.filter(f => f.tbDadosImplantacaoTim_Id == dadosImplantacaoTim_Id).length > 0)}
                                    onChange={(o) => handleChangeLojas(o)}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                    isMulti={true}
                                    ref={e => register(
                                        { name: "lojas" },
                                        { required: perfil == "Grupo Econômico" })
                                    }
                                    isDisabled={isDisable}
                                />
                                {errors.lojas && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        
                    </Row>
                    <h5 className='mt-4'>Lista de Permissões de Acesso</h5>
                    <Row>
                        <Col lg="12" md="12" sm="12" className={(perfil == "Canal" || perfil == "Grupo Econômico") ? "" : "d-none"}>
                            <Card className="p-3">
                                <Row className="align-items-center">
                                    <Col lg="6" md="6" sm="12">
                                        <label className="form-control-label">
                                            <i className="fas fa-lock-open"></i> Permissão para editar Receitas Adicionais
                                            <span className="text-muted"> - Manutenção DRE </span>
                                        </label>
                                        <p className="text-muted small">Habilitar edição do campo "Receitas Adicionais" na tela de Manutenção DRE</p>
                                    </Col>
                                    <Col lg="6" md="6" sm="12" className="text-right">
                                        {(() => {
                                            const session = getSessionCookie();
                                            const isReceitasAdicionaisToggleDisabled = isDisable || session?.perfil === "Grupo Econômico";
                                            return (
                                                <Switch
                                                    checked={permiteEditarReceitasAdicionais}
                                                    onChange={handleChangeReceitasAdicionaisPermission}
                                                    onColor="#86d3ff"
                                                    onHandleColor="#2693e6"
                                                    disabled={isReceitasAdicionaisToggleDisabled}
                                                    width={60}
                                                    height={30}
                                                />
                                            );
                                        })()}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        {options_funcionalidades.map((m, key) => (
                            <Col lg="3" md="6" sm="12" key={key}>
                                <Card className="subcard">
                                    <CardHeader>{m.descricao}</CardHeader>
                                    <CardBody>
                                        <Row>
                                            {
                                                m.funcionalidadeAcos.map((n, key2) => (
                                                    <Col lg="12" md="12" sm="12" key={key2}>
                                                        <FormGroup>
                                                            <label htmlFor={n.funcionalidadeAcao_Id}>
                                                                <span>{n.acao}</span>
                                                                <Switch
                                                                    id={n.funcionalidadeAcao_Id}
                                                                    className="react-switch"
                                                                    checked={usuarioFuncionalidadeAcoes.filter(f => f.funcionalidadeAcao_Id == n.funcionalidadeAcao_Id).length > 0}
                                                                    onChange={(checked) => handleChangeFuncionalidadesAcoes(n.funcionalidadeAcao_Id, checked)}
                                                                    onColor="#86d3ff"
                                                                    onHandleColor="#2693e6"
                                                                    disabled={isDisable}
                                                                />
                                                            </label>
                                                        </FormGroup>
                                                    </Col>
                                                ))}
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-center">
                            <Button color="link" onClick={Voltar}>Voltar</Button>
                            {!isDisable && <Button color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>}
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}

